/* tslint:disable */
/* eslint-disable */
/**
 * Stotles Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateUserRequest,
  CreateUserResponse,
  DescribeCompanyRequest,
  DescribeCompanyResponse,
  DescribeUserRequest,
  DescribeUserResponse,
  FeedSettingsPreviewRequest,
  FeedSettingsQueryPreviewResponse,
  GenerateRecordSectionResponse,
  GenerateRecordsSectionRequest,
  ListSavedViewsRequest,
  ListSavedViewsResponse,
  MergeCompanyRequest,
  MergeCompanyResponse,
  SaveDataSourcesRequest,
  SaveReportRequest,
  SaveReportRequest200Response,
  ScrapeLinkMetadataRequest,
  ScrapeLinkMetadataResponse,
  SearchCompaniesRequest,
  SearchCompaniesResponse,
  SearchRolesRequest,
  SearchRolesResponse,
  SearchTeamsRequest,
  SearchTeamsResponse,
  UpdateUserDetailsRequest,
  UpsertSavedViewsRequest,
  UserDetails,
  UserSearchRequest,
  UserSearchResponse,
} from '../models';
import {
    CreateUserRequestFromJSON,
    CreateUserRequestToJSON,
    CreateUserResponseFromJSON,
    CreateUserResponseToJSON,
    DescribeCompanyRequestFromJSON,
    DescribeCompanyRequestToJSON,
    DescribeCompanyResponseFromJSON,
    DescribeCompanyResponseToJSON,
    DescribeUserRequestFromJSON,
    DescribeUserRequestToJSON,
    DescribeUserResponseFromJSON,
    DescribeUserResponseToJSON,
    FeedSettingsPreviewRequestFromJSON,
    FeedSettingsPreviewRequestToJSON,
    FeedSettingsQueryPreviewResponseFromJSON,
    FeedSettingsQueryPreviewResponseToJSON,
    GenerateRecordSectionResponseFromJSON,
    GenerateRecordSectionResponseToJSON,
    GenerateRecordsSectionRequestFromJSON,
    GenerateRecordsSectionRequestToJSON,
    ListSavedViewsRequestFromJSON,
    ListSavedViewsRequestToJSON,
    ListSavedViewsResponseFromJSON,
    ListSavedViewsResponseToJSON,
    MergeCompanyRequestFromJSON,
    MergeCompanyRequestToJSON,
    MergeCompanyResponseFromJSON,
    MergeCompanyResponseToJSON,
    SaveDataSourcesRequestFromJSON,
    SaveDataSourcesRequestToJSON,
    SaveReportRequestFromJSON,
    SaveReportRequestToJSON,
    SaveReportRequest200ResponseFromJSON,
    SaveReportRequest200ResponseToJSON,
    ScrapeLinkMetadataRequestFromJSON,
    ScrapeLinkMetadataRequestToJSON,
    ScrapeLinkMetadataResponseFromJSON,
    ScrapeLinkMetadataResponseToJSON,
    SearchCompaniesRequestFromJSON,
    SearchCompaniesRequestToJSON,
    SearchCompaniesResponseFromJSON,
    SearchCompaniesResponseToJSON,
    SearchRolesRequestFromJSON,
    SearchRolesRequestToJSON,
    SearchRolesResponseFromJSON,
    SearchRolesResponseToJSON,
    SearchTeamsRequestFromJSON,
    SearchTeamsRequestToJSON,
    SearchTeamsResponseFromJSON,
    SearchTeamsResponseToJSON,
    UpdateUserDetailsRequestFromJSON,
    UpdateUserDetailsRequestToJSON,
    UpsertSavedViewsRequestFromJSON,
    UpsertSavedViewsRequestToJSON,
    UserDetailsFromJSON,
    UserDetailsToJSON,
    UserSearchRequestFromJSON,
    UserSearchRequestToJSON,
    UserSearchResponseFromJSON,
    UserSearchResponseToJSON,
} from '../models';

export interface CreateUserOperationRequest {
    createUserRequest: CreateUserRequest;
}

export interface DeleteUserRequest {
    id: string;
}

export interface DescribeCompanyOperationRequest {
    describeCompanyRequest: DescribeCompanyRequest;
}

export interface DescribeUserOperationRequest {
    describeUserRequest: DescribeUserRequest;
}

export interface GenerateRecordsSectionOperationRequest {
    generateRecordsSectionRequest: GenerateRecordsSectionRequest;
}

export interface GetUserDetailsRequest {
    id: string;
}

export interface ListSavedViewsOperationRequest {
    listSavedViewsRequest: ListSavedViewsRequest;
}

export interface MergeCompanyOperationRequest {
    mergeCompanyRequest: MergeCompanyRequest;
}

export interface PreviewFeedSettingsQueryRequest {
    feedSettingsPreviewRequest: FeedSettingsPreviewRequest;
}

export interface SaveDataSourcesOperationRequest {
    saveDataSourcesRequest: SaveDataSourcesRequest;
}

export interface SaveReportRequestRequest {
    saveReportRequest: SaveReportRequest;
}

export interface ScrapeLinkMetadataOperationRequest {
    scrapeLinkMetadataRequest: ScrapeLinkMetadataRequest;
}

export interface SearchCompaniesOperationRequest {
    searchCompaniesRequest: SearchCompaniesRequest;
}

export interface SearchRolesOperationRequest {
    searchRolesRequest: SearchRolesRequest;
}

export interface SearchTeamsOperationRequest {
    searchTeamsRequest: SearchTeamsRequest;
}

export interface SearchUsersRequest {
    userSearchRequest: UserSearchRequest;
}

export interface UpdateUserDetailsOperationRequest {
    id: string;
    updateUserDetailsRequest: UpdateUserDetailsRequest;
}

export interface UpsertSavedViewsOperationRequest {
    upsertSavedViewsRequest: UpsertSavedViewsRequest;
}

/**
 * 
 */
export class DefaultApi extends runtime.BaseAPI {

    /**
     */
    async createUserRaw(requestParameters: CreateUserOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateUserResponse>> {
        if (requestParameters.createUserRequest === null || requestParameters.createUserRequest === undefined) {
            throw new runtime.RequiredError('createUserRequest','Required parameter requestParameters.createUserRequest was null or undefined when calling createUser.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/admin/api/users`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUserRequestToJSON(requestParameters.createUserRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateUserResponseFromJSON(jsonValue));
    }

    /**
     */
    async createUser(requestParameters: CreateUserOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateUserResponse> {
        const response = await this.createUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async deleteUserRaw(requestParameters: DeleteUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteUser.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/admin/api/users/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteUser(requestParameters: DeleteUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteUserRaw(requestParameters, initOverrides);
    }

    /**
     */
    async describeCompanyRaw(requestParameters: DescribeCompanyOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DescribeCompanyResponse>> {
        if (requestParameters.describeCompanyRequest === null || requestParameters.describeCompanyRequest === undefined) {
            throw new runtime.RequiredError('describeCompanyRequest','Required parameter requestParameters.describeCompanyRequest was null or undefined when calling describeCompany.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/admin/api/companies/describe`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DescribeCompanyRequestToJSON(requestParameters.describeCompanyRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DescribeCompanyResponseFromJSON(jsonValue));
    }

    /**
     */
    async describeCompany(requestParameters: DescribeCompanyOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DescribeCompanyResponse> {
        const response = await this.describeCompanyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async describeUserRaw(requestParameters: DescribeUserOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DescribeUserResponse>> {
        if (requestParameters.describeUserRequest === null || requestParameters.describeUserRequest === undefined) {
            throw new runtime.RequiredError('describeUserRequest','Required parameter requestParameters.describeUserRequest was null or undefined when calling describeUser.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/admin/api/users/describe`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DescribeUserRequestToJSON(requestParameters.describeUserRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DescribeUserResponseFromJSON(jsonValue));
    }

    /**
     */
    async describeUser(requestParameters: DescribeUserOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DescribeUserResponse> {
        const response = await this.describeUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async generateRecordsSectionRaw(requestParameters: GenerateRecordsSectionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GenerateRecordSectionResponse>> {
        if (requestParameters.generateRecordsSectionRequest === null || requestParameters.generateRecordsSectionRequest === undefined) {
            throw new runtime.RequiredError('generateRecordsSectionRequest','Required parameter requestParameters.generateRecordsSectionRequest was null or undefined when calling generateRecordsSection.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/admin/report_configs/generate_records_section`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GenerateRecordsSectionRequestToJSON(requestParameters.generateRecordsSectionRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GenerateRecordSectionResponseFromJSON(jsonValue));
    }

    /**
     */
    async generateRecordsSection(requestParameters: GenerateRecordsSectionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GenerateRecordSectionResponse> {
        const response = await this.generateRecordsSectionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getUserDetailsRaw(requestParameters: GetUserDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserDetails>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getUserDetails.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/admin/api/users/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserDetailsFromJSON(jsonValue));
    }

    /**
     */
    async getUserDetails(requestParameters: GetUserDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserDetails> {
        const response = await this.getUserDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async listSavedViewsRaw(requestParameters: ListSavedViewsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListSavedViewsResponse>> {
        if (requestParameters.listSavedViewsRequest === null || requestParameters.listSavedViewsRequest === undefined) {
            throw new runtime.RequiredError('listSavedViewsRequest','Required parameter requestParameters.listSavedViewsRequest was null or undefined when calling listSavedViews.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/admin/api/pinned_saved_views/list_saved_views`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ListSavedViewsRequestToJSON(requestParameters.listSavedViewsRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListSavedViewsResponseFromJSON(jsonValue));
    }

    /**
     */
    async listSavedViews(requestParameters: ListSavedViewsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListSavedViewsResponse> {
        const response = await this.listSavedViewsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async mergeCompanyRaw(requestParameters: MergeCompanyOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MergeCompanyResponse>> {
        if (requestParameters.mergeCompanyRequest === null || requestParameters.mergeCompanyRequest === undefined) {
            throw new runtime.RequiredError('mergeCompanyRequest','Required parameter requestParameters.mergeCompanyRequest was null or undefined when calling mergeCompany.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/admin/api/companies/merge`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MergeCompanyRequestToJSON(requestParameters.mergeCompanyRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MergeCompanyResponseFromJSON(jsonValue));
    }

    /**
     */
    async mergeCompany(requestParameters: MergeCompanyOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MergeCompanyResponse> {
        const response = await this.mergeCompanyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async previewFeedSettingsQueryRaw(requestParameters: PreviewFeedSettingsQueryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FeedSettingsQueryPreviewResponse>> {
        if (requestParameters.feedSettingsPreviewRequest === null || requestParameters.feedSettingsPreviewRequest === undefined) {
            throw new runtime.RequiredError('feedSettingsPreviewRequest','Required parameter requestParameters.feedSettingsPreviewRequest was null or undefined when calling previewFeedSettingsQuery.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/admin/company/feed_settings/preview_query`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FeedSettingsPreviewRequestToJSON(requestParameters.feedSettingsPreviewRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FeedSettingsQueryPreviewResponseFromJSON(jsonValue));
    }

    /**
     */
    async previewFeedSettingsQuery(requestParameters: PreviewFeedSettingsQueryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FeedSettingsQueryPreviewResponse> {
        const response = await this.previewFeedSettingsQueryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async saveDataSourcesRaw(requestParameters: SaveDataSourcesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.saveDataSourcesRequest === null || requestParameters.saveDataSourcesRequest === undefined) {
            throw new runtime.RequiredError('saveDataSourcesRequest','Required parameter requestParameters.saveDataSourcesRequest was null or undefined when calling saveDataSources.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/admin/company/data_sources/save`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SaveDataSourcesRequestToJSON(requestParameters.saveDataSourcesRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async saveDataSources(requestParameters: SaveDataSourcesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.saveDataSourcesRaw(requestParameters, initOverrides);
    }

    /**
     */
    async saveReportRequestRaw(requestParameters: SaveReportRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SaveReportRequest200Response>> {
        if (requestParameters.saveReportRequest === null || requestParameters.saveReportRequest === undefined) {
            throw new runtime.RequiredError('saveReportRequest','Required parameter requestParameters.saveReportRequest was null or undefined when calling saveReportRequest.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/admin/report_configs/save_report`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SaveReportRequestToJSON(requestParameters.saveReportRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SaveReportRequest200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async saveReportRequest(requestParameters: SaveReportRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SaveReportRequest200Response> {
        const response = await this.saveReportRequestRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async scrapeLinkMetadataRaw(requestParameters: ScrapeLinkMetadataOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ScrapeLinkMetadataResponse>> {
        if (requestParameters.scrapeLinkMetadataRequest === null || requestParameters.scrapeLinkMetadataRequest === undefined) {
            throw new runtime.RequiredError('scrapeLinkMetadataRequest','Required parameter requestParameters.scrapeLinkMetadataRequest was null or undefined when calling scrapeLinkMetadata.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/admin/report_configs/scrape_link`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ScrapeLinkMetadataRequestToJSON(requestParameters.scrapeLinkMetadataRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ScrapeLinkMetadataResponseFromJSON(jsonValue));
    }

    /**
     */
    async scrapeLinkMetadata(requestParameters: ScrapeLinkMetadataOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ScrapeLinkMetadataResponse> {
        const response = await this.scrapeLinkMetadataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async searchCompaniesRaw(requestParameters: SearchCompaniesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchCompaniesResponse>> {
        if (requestParameters.searchCompaniesRequest === null || requestParameters.searchCompaniesRequest === undefined) {
            throw new runtime.RequiredError('searchCompaniesRequest','Required parameter requestParameters.searchCompaniesRequest was null or undefined when calling searchCompanies.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/admin/api/companies/search`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SearchCompaniesRequestToJSON(requestParameters.searchCompaniesRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchCompaniesResponseFromJSON(jsonValue));
    }

    /**
     */
    async searchCompanies(requestParameters: SearchCompaniesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchCompaniesResponse> {
        const response = await this.searchCompaniesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async searchRolesRaw(requestParameters: SearchRolesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchRolesResponse>> {
        if (requestParameters.searchRolesRequest === null || requestParameters.searchRolesRequest === undefined) {
            throw new runtime.RequiredError('searchRolesRequest','Required parameter requestParameters.searchRolesRequest was null or undefined when calling searchRoles.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/admin/api/roles/search`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SearchRolesRequestToJSON(requestParameters.searchRolesRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchRolesResponseFromJSON(jsonValue));
    }

    /**
     */
    async searchRoles(requestParameters: SearchRolesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchRolesResponse> {
        const response = await this.searchRolesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async searchTeamsRaw(requestParameters: SearchTeamsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchTeamsResponse>> {
        if (requestParameters.searchTeamsRequest === null || requestParameters.searchTeamsRequest === undefined) {
            throw new runtime.RequiredError('searchTeamsRequest','Required parameter requestParameters.searchTeamsRequest was null or undefined when calling searchTeams.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/admin/api/teams/search`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SearchTeamsRequestToJSON(requestParameters.searchTeamsRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchTeamsResponseFromJSON(jsonValue));
    }

    /**
     */
    async searchTeams(requestParameters: SearchTeamsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchTeamsResponse> {
        const response = await this.searchTeamsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async searchUsersRaw(requestParameters: SearchUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserSearchResponse>> {
        if (requestParameters.userSearchRequest === null || requestParameters.userSearchRequest === undefined) {
            throw new runtime.RequiredError('userSearchRequest','Required parameter requestParameters.userSearchRequest was null or undefined when calling searchUsers.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/admin/api/users/search`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserSearchRequestToJSON(requestParameters.userSearchRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserSearchResponseFromJSON(jsonValue));
    }

    /**
     */
    async searchUsers(requestParameters: SearchUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserSearchResponse> {
        const response = await this.searchUsersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateUserDetailsRaw(requestParameters: UpdateUserDetailsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateUserDetails.');
        }

        if (requestParameters.updateUserDetailsRequest === null || requestParameters.updateUserDetailsRequest === undefined) {
            throw new runtime.RequiredError('updateUserDetailsRequest','Required parameter requestParameters.updateUserDetailsRequest was null or undefined when calling updateUserDetails.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/admin/api/users/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateUserDetailsRequestToJSON(requestParameters.updateUserDetailsRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateUserDetails(requestParameters: UpdateUserDetailsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateUserDetailsRaw(requestParameters, initOverrides);
    }

    /**
     */
    async upsertSavedViewsRaw(requestParameters: UpsertSavedViewsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.upsertSavedViewsRequest === null || requestParameters.upsertSavedViewsRequest === undefined) {
            throw new runtime.RequiredError('upsertSavedViewsRequest','Required parameter requestParameters.upsertSavedViewsRequest was null or undefined when calling upsertSavedViews.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/admin/api/pinned_saved_views/upsert_saved_views`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpsertSavedViewsRequestToJSON(requestParameters.upsertSavedViewsRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async upsertSavedViews(requestParameters: UpsertSavedViewsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.upsertSavedViewsRaw(requestParameters, initOverrides);
    }

}
